<!-- Alarms Related Toast messages -->

<p-toast key="alarm-update" position="top-center" preventOpenDuplicates="true">
  <ng-template let-message pTemplate="message">
    <div>
      <div class="flex">
        <em
          *ngIf="message.severity === 'success'"
          class="fa fa-check-circle"
          aria-hidden="true"
        ></em>
        <em
          *ngIf="message.severity === 'error'"
          class="fa fa-times-circle"
          aria-hidden="true"
        ></em>
        <p class="msg-summary">
          {{ message.summary }}
        </p>
      </div>
      <div class="flex">
        <p class="msg-body">{{ message.detail }}</p>
      </div>
    </div>
  </ng-template>
</p-toast>

<!-- Users Related Toast messages -->

<p-toast key="common-toast" position="top-center" preventOpenDuplicates="true">
  <ng-template let-message pTemplate="message">
    <div>
      <div class="flex">
        <em
          *ngIf="message.severity === 'success'"
          class="fa fa-check-circle"
          aria-hidden="true"
        ></em>
        <em
          *ngIf="message.severity === 'error'"
          class="fa fa-times-circle"
          aria-hidden="true"
        ></em>
        <em
          *ngIf="message.severity === 'warn'"
          class="fa fa-exclamation-circle"
          aria-hidden="true"
        ></em>
        <p class="msg-summary">
          {{ message.summary }}
        </p>
      </div>
      <div class="flex">
        <p class="msg-body">{{ message.detail }}</p>
      </div>
    </div>
  </ng-template>
</p-toast>

<!-- Rules related toast messages -->

<p-toast key="rule" position="top-center" preventOpenDuplicates="true">
  <ng-template let-message pTemplate="message">
    <div>
      <div class="flex">
        <em
          *ngIf="message.severity === 'success'"
          class="fa fa-check-circle"
          aria-hidden="true"
        ></em>
        <em
          *ngIf="message.severity === 'error'"
          class="fa fa-times-circle"
          aria-hidden="true"
        ></em>
        <p class="msg-summary">
          {{ message.summary }}
        </p>
      </div>
      <div class="flex">
        <p class="msg-body">{{ message.detail }}</p>
      </div>
    </div>
  </ng-template>
</p-toast>

<!-- Device management toast -->

<p-toast key="device-update" position="top-center" preventOpenDuplicates="true">
  <ng-template let-message pTemplate="message">
    <div>
      <div class="flex">
        <em
          *ngIf="message.severity === 'success'"
          class="fa fa-check-circle"
          aria-hidden="true"
        ></em>
        <em
          *ngIf="message.severity === 'error'"
          class="fa fa-times-circle"
          aria-hidden="true"
        ></em>
        <p class="msg-summary">
          {{ message.summary }}
        </p>
      </div>
      <div class="flex">
        <p class="msg-body">{{ message.detail }}</p>
      </div>
    </div>
  </ng-template>
</p-toast>

<!-- Rule Management Toast -->

<p-toast key="rule-status" position="top-center" preventOpenDuplicates="true">
  <ng-template let-message pTemplate="message">
    <div>
      <div class="flex">
        <em
          *ngIf="message.severity === 'success'"
          class="fa fa-check-circle"
          aria-hidden="true"
        ></em>
        <em
          *ngIf="message.severity === 'error'"
          class="fa fa-times-circle"
          aria-hidden="true"
        ></em>
        <p class="msg-summary">
          {{ message.summary }}
        </p>
      </div>
      <div class="flex">
        <p class="msg-body">{{ message.detail }}</p>
      </div>
    </div>
  </ng-template>
</p-toast>

<!--Permission Access-->

<p-toast key="access" position="top-center" preventOpenDuplicates="true">
  <ng-template let-message pTemplate="message">
    <div>
      <div class="flex">
        <em
          *ngIf="message.severity === 'success'"
          class="fa fa-check-circle"
          aria-hidden="true"
        ></em>
        <em
          *ngIf="message.severity === 'error'"
          class="fa fa-times-circle"
          aria-hidden="true"
        ></em>
        <p class="msg-summary">
          {{ message.summary }}
        </p>
      </div>
      <div class="flex">
        <p class="msg-body">{{ message.detail }}</p>
      </div>
    </div>
  </ng-template>
</p-toast>
